module.exports = __webpack_public_path__ + "static/img/fingerpost_refund_1.7224a57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerpost/fingerpost_refund_1.jpg
// module id = ZpTK
// module chunks = 0